import React, { useCallback } from 'react';

import { useScreenDispatch, useScreenState } from '@gogame/screens';

import { useLoadKPIChart } from 'scenes/KPI/data';
import {
  SHOW_CHART_ANNOTATIONS,
  HIDE_CHART_ANNOTATIONS,
  SET_CHART_VIEW_SETTINGS,
  SET_CHART_SETTINGS,
} from 'scenes/KPI/reducers';

import KPIChart from './KPIChart';

const KPIDataChart = ({
  withPaper,
  tooltipPosStrategy,
  style,
  idColorGetter,
}) => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();
  const { period, series, temporary } = screenState;
  const visibleSeries = temporary?.series || series;
  const visiblePeriod = temporary?.period || period;

  const { data, isLoading: loading } = useLoadKPIChart({
    period: period,
    series: series,
    trend: true,
    keepPreviousData: visibleSeries.length > 0,
    enabled: !temporary && series.length > 0,
  });
  const handleShowAnnotations = useCallback(
    (value) => {
      dispatch({
        type: SHOW_CHART_ANNOTATIONS,
        payload: value,
      });
    },
    [dispatch]
  );

  const handleHideAnnotations = useCallback(() => {
    dispatch({
      type: HIDE_CHART_ANNOTATIONS,
    });
  }, [dispatch]);

  const handleChangeChartViewSettings = useCallback(
    (value) => {
      dispatch({
        type: SET_CHART_VIEW_SETTINGS,
        payload: value,
      });
    },
    [dispatch]
  );

  const handleChangeChartSettings = useCallback(
    (value) => {
      dispatch({
        type: SET_CHART_SETTINGS,
        payload: value,
      });
    },
    [dispatch]
  );

  return (
    <KPIChart
      data={data?.data}
      loading={loading}
      period={period}
      series={series}
      visibleSeries={visibleSeries}
      visiblePeriod={visiblePeriod}
      onShowAnnotations={handleShowAnnotations}
      onHideAnnotations={handleHideAnnotations}
      onChangeViewSettings={handleChangeChartViewSettings}
      onChangeSettings={handleChangeChartSettings}
      viewSettings={screenState.chartViewSettings}
      annotationsSettings={screenState.annotations}
      settings={screenState.chartSettings}
      hiddenSeries={screenState.hidden}
      columnsOrder={screenState.columns.order}
      tooltipPosStrategy={tooltipPosStrategy}
      withPaper={withPaper}
      style={style}
      idColorGetter={idColorGetter}
    />
  );
};

export default KPIDataChart;
